module.exports = __webpack_public_path__ + "img/Frueher-1024.817a0b1a.jpg";